/**
 * ai 接口
 */
import axios from '@/util/request'

const baseURL = process.env.VUE_APP_API_URL

export default {
  aiCustomImg: data => axios({ baseURL, url: '/api/product/custom/ai/img', method: 'POST', data }), // 新增调用AI图生图
  aiCustomImgList: data => axios({ baseURL, url: '/api/product/custom/ai/img/list', method: 'POST', data }), // 获取历史AI生成图生图列表
  aiCustomImgSet: data => axios({ baseURL, url: '/api/product/custom/ai/img', method: 'PUT', data }), // 修改移除AI图片
  aiCustomImgStop: data => axios({ baseURL, url: '/api/product/custom/stop/ai/img', method: 'PUT', data }), // 停止生成AI图片
  aiCustomImgStatus: params => axios({ baseURL, url: '/api/product/custom/ai/img/status', method: 'GET', params }), // 获取实时AI生成图生图状态
  aiWaitingOrProgress: params => axios({ baseURL, url: '/api/product/custom/ai/img/waitingOrProgress/taskId', method: 'GET', params }) // 前台-获取当前用户AI图生图的待生成及生成中的任务ID

}
